import gql from 'graphql-tag';

export const mutationDeleteStarredObject = gql`
  mutation deleteStarredObject (
    $conversationID: DokkioID
    $dokkioTagID: DokkioID
    $integrationID: DokkioID
    $remoteID: String
    $integrationItemKind: IntegrationItemKind
  ) {
    deleteStarredObject (
      conversationID: $conversationID
      dokkioTagID: $dokkioTagID
      integrationID: $integrationID
      remoteID: $remoteID
      integrationItemKind: $integrationItemKind
    )
  }
`;
export default mutationDeleteStarredObject;
